import type { ReceiptCenterQueries, ReceiptPageQuery, ReceiptsState } from './receiptsTypes';

const createPageQuery = (): ReceiptPageQuery => ({
  page: 0,
  pageSize: 25,
  sort: { field: 'uploadedDate', direction: 'desc' },
  ids: [],
  total: 0,
  isLoading: false,
  loaded: false,
  revision: 0,
  error: null,
});

export const createReceiptCenterQueries = (): ReceiptCenterQueries => ({
  enabled: false,
  activeReviewState: 'NEEDS_REVIEW',
  pages: {
    NEEDS_REVIEW: createPageQuery(),
    REVIEWED: createPageQuery(),
    PROCESSING_OR_ERROR: createPageQuery(),
  },
  summary: null,
  summaryError: null,
  summaryPendingReceiptIds: [],
  revision: 0,
});

export const invalidateReceiptCenterQueries = (state: ReceiptsState, includeProcessing = true): void => {
  if (!state.center?.enabled) return;
  state.center.revision += 1;
  state.center.summaryRequestId = undefined;
  for (const [reviewState, page] of Object.entries(state.center.pages)) {
    if (!includeProcessing && reviewState === 'PROCESSING_OR_ERROR') continue;
    page.revision += 1;
    page.requestId = undefined;
    page.isLoading = false;
  }
};
